import { useContext, Component } from 'react';
import { Container } from 'reactstrap';
import { AuthenticationContext } from '../../../msal/AuthenticationContext';
import { NotificationContext } from '../../../context/NotificationContext';
import { TenantContext } from '../../../context/TenantContext';
import { TenantAuditTrailConfig } from './TenantAuditTrailConfig';
import * as misc from '../../../utils/misc';
import * as apiCalls from '../../../logic/apiCalls';

class GlobalSettingsInternal extends Component {
    state = {
        isLoading: true,
    }

    // Get the tenant info and WAN IP address when the page is loaded.    
    async componentDidMount() {
        await this.props.tenantContext.refreshTenant();
        this.setState({
            isLoading: false,
        });
    }

    executeAuditTrailConfigChange = (newAuditTrailRetentionDays) => {
        console.log(`Change audit trail config`);

        this.executeSaveAuditTrailRetention(newAuditTrailRetentionDays);
    }

    executeSaveAuditTrailRetention = async (auditTrailRetentionDays) => {
        try
        {
            await apiCalls.tenantUpdateAuditTrailRetention(this.props.authenticationContext,
                auditTrailRetentionDays);

            this.props.notificationContext.setNotification(`Updating tenant.`, `Successfully updated tenant audit-trail retention to ${misc.daysToMonths(auditTrailRetentionDays)} months.`, 'success');
            this.props.tenantContext.refreshTenant();
            this.setState({
                newWanIpAddressValue: ""
            });
        }
        catch (err) {
            this.props.notificationContext.setNotification(`Updating tenant.`, `Error updating tenant audit-trail retention to ${misc.daysToMonths(auditTrailRetentionDays)} months.  ${err.toDetailedMessage()}`, 'danger');
        }
    }

    // ------------------------------
    // Rendering starts here...
    // ------------------------------
    render() {
        let headerRendered = <h1>Global settings</h1>

        if (this.state.isLoading) {
            return (
                <Container fluid>
                    <div>
                        {headerRendered}
                        {this.props.tenantContext.showWarningWhenDisabled()}
                        <p><em>Loading...</em></p>
                    </div>
                </Container>
            );
        }

        return (
            <Container fluid>
                {headerRendered}
                {this.props.tenantContext.showWarningWhenDisabled()}
                <div><br/></div>            
                <TenantAuditTrailConfig tenantInfo={this.props.tenantContext} onConfigChange={this.executeAuditTrailConfigChange}/>
                <br/>
                <br/>
            </Container>
        );
    }
}

export const GlobalSettings = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
    const notificationContext = useContext(NotificationContext);
    const tenantContext = useContext(TenantContext);
  
    return (
        <GlobalSettingsInternal authenticationContext={authenticationContext} notificationContext={notificationContext} tenantContext={tenantContext} {...props}/>
    )
}